import axios from "axios";

const cloudfrontApiInstance = axios.create({
  baseURL: process.env.REACT_APP_CLOUDFRONT_MASTER_DATA_URL,
  validateStatus: function (status) {
    return status < 400;
  }
});

export default cloudfrontApiInstance;